/**
 * /tracking/android-app-links — Android App Links configuration (feat #179).
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AndroidAppLinksPage } from "@/features/android-app-links/AndroidAppLinksPage";

export const trackingAndroidAppLinksRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/android-app-links",
	component: TrackingAndroidAppLinksRoute,
});

export default trackingAndroidAppLinksRoute;

export function TrackingAndroidAppLinksRoute() {
	return (
		<div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-6 pt-6 sm:pt-10">
			<Breadcrumb />
			<AndroidAppLinksPage />
		</div>
	);
}

function Breadcrumb() {
	return (
		<nav aria-label="Breadcrumb" className="text-sm text-zinc-500">
			<ol className="flex flex-wrap items-center gap-1">
				<li>
					<Link
						to="/"
						className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
					>
						Dashboard
					</Link>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li>
					<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li className="text-zinc-900">Android App Links</li>
			</ol>
		</nav>
	);
}

export { TrackingAndroidAppLinksRoute as TrackingAndroidAppLinksPage };
